<template>
  <div>
    <VideoFeaturedSection />
    <SlideShowSection />
    <AboutSection />
    <ProductsSection />
    <PartnersSection />
    <ContactSection />
  </div>
</template>

<script>
import VideoFeaturedSection from "../components/sections/VideoFeaturedSection.vue";
import AboutSection from "../components/sections/AboutSection.vue";
import ProductsSection from "../components/sections/ProductsSection.vue";
import PartnersSection from "../components/sections/PartnersSection.vue";
import ContactSection from "../components/sections/ContactSection.vue";
import SlideShowSection from "../components/sections/SlideShowSection.vue";

export default {
  components: {
    VideoFeaturedSection,
    AboutSection,
    ProductsSection,
    PartnersSection,
    ContactSection,
    SlideShowSection,
  },
};
</script>
